import React from 'react';
import { Box, RangeSlider, ScoreLabel, Typography } from '@scope/scope-one-ui/core';
import { ScoreLabelProps, ScoreFormat } from '@scope/scope-one-ui/core/ScoreLabel/ScoreLabel.d';
import { LabelType } from '@scope/scope-one-ui/core/Label/Label.d';
import { COLORS } from '@scope/scope-one-ui/theme';
import { EventMeta, EventRangeScore, GroupInfo } from '../types/esgSentiment';
import { Dot, SentimentLabel } from '../components/ESGSentiment.styled';

export const groupComparisonRenderer = ({ name, type }: GroupInfo) => (
  <Box display="flex" alignItems="center" gridGap={2}>
    <Dot groupType={type} />
    <Typography variant="h3" color={COLORS.typography.label}>
      {name}
    </Typography>
  </Box>
);

export const sentimentRenderer = ({ name, sentiment }: EventMeta) => {
  const type = { negative: 'negative', neutral: 'neutral', positive: 'positive' }[sentiment];

  return (
    <Box flex={1} display="flex" justifyContent="space-between" gridGap={2}>
      <Box display="flex" gridGap={2} alignItems="center">
        <Typography variant="h3" color={COLORS.typography.label}>
          {name}
        </Typography>
      </Box>
      <SentimentLabel type={type as LabelType}>{sentiment}</SentimentLabel>
    </Box>
  );
};

export const scoreRenderer = (format: ScoreFormat) => (score: ScoreLabelProps) =>
  <ScoreLabel {...score} format={format} />;

export const rangeRenderer = ({ min, max, value }: EventRangeScore) => (
  <Box flex={1} pt={2}>
    <RangeSlider min={min} max={max} value={value} />
  </Box>
);
